import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import { siteInfo, faqs } from '@/mocks/data';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 明星黑料大全',
    description: siteInfo.description,
    url: `${siteInfo.url}/about`,
    mainEntity: {
      '@type': 'Organization',
      name: siteInfo.name,
      url: siteInfo.url,
      email: siteInfo.email,
      telephone: siteInfo.phone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: siteInfo.address,
        addressLocality: '北京',
        addressRegion: '北京',
        addressCountry: 'CN',
      },
      foundingDate: siteInfo.founded,
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 明星黑料大全 | 品牌介绍、口碑与联系方式"
        description={`${siteInfo.name}——${siteInfo.description}。了解我们的品牌故事、媒体口碑以及联系方式。`}
        keywords="明星黑料大全,关于我们,联系我们,品牌介绍,娱乐新闻媒体"
        canonicalUrl={`${siteInfo.url}/about`}
        schemaJson={{ ...aboutSchema, ...faqSchema }}
      />
      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="bg-foreground-950 text-background-50 py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading font-bold text-3xl md:text-4xl mb-4">关于我们</h1>
            <p className="text-foreground-400 max-w-2xl mx-auto text-sm md:text-base">
              了解明星黑料大全的品牌故事与发展历程
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mb-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  <strong>{siteInfo.name}</strong>成立于{siteInfo.founded}年，是国内领先的娱乐八卦资讯平台。
                  我们致力于为广大网友提供最新、最全、最真实的明星黑料与娱乐圈内幕资讯。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  在娱乐圈光鲜亮丽的表面之下，隐藏着许多不为人知的秘密。
                  我们的编辑团队由资深娱乐记者、调查记者和行业内部人士组成，凭借多年的行业经验和广泛的人脉网络，
                  持续为您挖掘娱乐圈最劲爆的独家内幕。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  从流量小生的私生活揭秘，到顶流明星的法律纠纷追踪；从选秀节目的黑幕曝光，
                  到行业潜规则的深度调查——我们始终站在娱乐八卦资讯的最前沿。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  我们坚持新闻真实性原则，所有报道均经过多源交叉验证。
                  对于无法完全核实的信息，我们会明确标注，绝不混淆视听。
                  我们相信，公众有权了解娱乐圈的真实面貌。
                </p>
              </div>
              <div className="rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20office%20with%20journalists%20working%20on%20computers%2C%20professional%20media%20company%20interior%2C%20warm%20lighting%2C%20clean%20minimalist%20design%2C%20editorial%20environment%2C%20Chinese%20media%20office&width=600&height=400&seq=about-brand&orientation=landscape"
                  alt="明星黑料大全品牌形象"
                  title="明星黑料大全 - 品牌形象"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-8 text-center">
              媒体口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { source: '新浪娱乐', quote: '"明星黑料大全是国内娱乐八卦资讯领域的佼佼者，以其真实的报道和独家爆料赢得了广大读者的信赖。"' },
                { source: '腾讯新闻', quote: '"内容扎实，爆料及时，深度调查类文章尤其值得一读。是了解娱乐圈真实一面的重要窗口。"' },
                { source: '网易娱乐', quote: '"在娱乐资讯泛滥的今天，明星黑料大全坚持真实性的态度令人敬佩。每一条爆料都有据可查。"' },
              ].map((item, i) => (
                <div key={i} className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                  <i className="ri-double-quotes-l text-3xl text-primary-400 mb-3 block"></i>
                  <p className="text-foreground-700 text-sm leading-relaxed mb-4">{item.quote}</p>
                  <p className="text-foreground-500 text-xs font-medium">—— {item.source}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-8 text-center">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {faqs.map((faq, i) => (
                <details key={i} className="group bg-background-50 border border-background-200/70 rounded-lg">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer font-medium text-foreground-900 hover:text-primary-600 transition-colors">
                    {faq.question}
                    <i className="ri-arrow-down-s-line text-lg transition-transform group-open:rotate-180"></i>
                  </summary>
                  <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-4xl mx-auto">
              <div className="space-y-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-medium text-foreground-950 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-600">{siteInfo.email}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-medium text-foreground-950 mb-1">联系电话</h4>
                    <p className="text-sm text-foreground-600">{siteInfo.phone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-secondary-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-medium text-foreground-950 mb-1">公司地址</h4>
                    <p className="text-sm text-foreground-600">{siteInfo.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                    <i className="ri-weibo-line text-accent-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-medium text-foreground-950 mb-1">新浪微博</h4>
                    <p className="text-sm text-foreground-600">@{siteInfo.social.weibo}</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <h3 className="font-heading font-bold text-lg text-foreground-950 mb-4">在线留言</h3>
                <form
                  id="contact-form"
                  data-readdy-form
                  action="https://readdy.ai/api/form/d9sloa58o1vn02ekuhj0"
                  method="POST"
                  encType="application/x-www-form-urlencoded"
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypotField = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
                    if (honeypotField && honeypotField.value.trim() !== '') {
                      alert('留言已提交，我们会尽快回复您！');
                      form.reset();
                      return;
                    }
                    const formData = new FormData(form);
                    try {
                      const res = await fetch(form.action, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const text = await res.text();
                      let parsed;
                      try { parsed = JSON.parse(text); } catch { parsed = {}; }
                      if (res.ok && parsed?.code === 'OK') {
                        alert('留言已提交，我们会尽快回复您！');
                        form.reset();
                      } else {
                        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
                        alert(msg);
                      }
                    } catch {
                      alert('网络错误，请稍后重试');
                    }
                  }}
                >
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1">留言内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent resize-none"
                      placeholder="请输入您的留言内容（最多500字）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    className="honeypot-field"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    提交留言
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}